import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '~/componentsPage/Header/Header';
import styles from '~/styles/Help/Help.module.css';

function Help() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  return (
    <div className={styles.pageContainer}>
      <Header />
      {/* CONTENT POMOCY */}
      <main className={styles.contactContent}>
        <section className={styles.contactHero}>
          <h1>Pomoc i FAQ</h1>
          <p>Znajdź odpowiedzi na najczęściej zadawane pytania dotyczące serwisu Czateria24.</p>
        </section>

        <div className={styles.infoGrid}>
          {/* FAQ CARD 1 */}
          <div className={styles.contactCard} style={{ textAlign: 'left' }}>
            <h3 style={{ color: 'var(--accent-color)', marginBottom: '15px' }}>Czy czat jest darmowy?</h3>
            <p>Tak, korzystanie z podstawowych funkcji serwisu Czateria24 jest całkowicie bezpłatne dla wszystkich użytkowników.</p>

            <h3 style={{ color: 'var(--accent-color)', margin: '25px 0 15px' }}>Czy muszę się rejestrować?</h3>
            <p>Nie, możesz rozmawiać jako gość. Rejestracja pozwala jednak na rezerwację nicku, posiadanie listy znajomych oraz personalizację profilu.</p>

            <h3 style={{ color: 'var(--accent-color)', margin: '25px 0 15px' }}>Jak zgłosić kogoś, kto łamie regulamin?</h3>
            <p>Możesz to zrobić bezpośrednio na czacie, klikając na nick użytkownika i wybierając opcję "Zgłoś", lub wysyłając e-mail na adres <strong>kontakt@czateria24.pl</strong>.</p>
          </div>

          {/* FAQ CARD 2 */}
          <div className={styles.contactCard} style={{ textAlign: 'left' }}>
            <h3 style={{ color: 'var(--accent-color)', marginBottom: '15px' }}>Dlaczego zostałem zablokowany?</h3>
            <p>Blokady (bany) są nakładane w przypadku złamania regulaminu, np. za mowę nienawiści, spamowanie lub wysyłanie nieodpowiednich treści.</p>

            <h3 style={{ color: 'var(--accent-color)', margin: '25px 0 15px' }}>Jak zmienić tryb kolorystyczny?</h3>
            <p>Możesz to zrobić klikając ikonę słońca/księżyca w prawym górnym rogu nagłówka. Twoje preferencje zostaną zapamiętane.</p>

            <h3 style={{ color: 'var(--accent-color)', margin: '25px 0 15px' }}>Nadal potrzebujesz pomocy?</h3>
            <p>Jeśli nie znalazłeś odpowiedzi na swoje pytanie, przejdź do zakładki <Link to="/kontakt" style={{ color: 'var(--accent-color)', fontWeight: 'bold' }}>Kontakt</Link> i napisz do nas bezpośrednio.</p>
          </div>
        </div>
      </main>

      {/* FOOTER */}
      <footer className={styles.mainFooter}>
        <div className={styles.footerContent}>
          <div className={styles.footerLinks}>
            <Link to="/pomoc">Pomoc</Link>
            <Link to="/kontakt">Kontakt</Link>
            <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
            <Link to="/regulamin">Regulamin</Link>
          </div>
          <div className={styles.disclaimer}>
            <p>Serwis <strong>Czateria24</strong> jest przeznaczony wyłącznie dla osób pełnoletnich. Cenimy Twoją prywatność i dbamy o bezpieczeństwo rozmów.</p>
          </div>
          <div className={styles.copyright}>© 2026 Czateria24. Wszystkie prawa zastrzeżone.</div>
        </div>
      </footer>
    </div>
  );
};

export default Help;